// components/DocumentEditor/ImageUpload/ProgressIndicator.jsx
import React from 'react';
import { MdCloudUpload, MdCheck, MdError } from 'react-icons/md';

/**
 * Shows upload progress and status
 */
const ProgressIndicator = ({ 
  visible, 
  progress = 0, 
  status = 'uploading', // 'uploading', 'success', 'error'
  message = '',
  filename = ''
}) => {
  if (!visible) return null;

  const getStatusIcon = () => {
    switch (status) {
      case 'success':
        return <MdCheck size={20} className="text-green-600" />;
      case 'error':
        return <MdError size={20} className="text-red-600" />;
      default:
        return <MdCloudUpload size={20} className="text-blue-600" />;
    }
  };

  const getStatusColor = () => {
    switch (status) {
      case 'success':
        return 'border-green-200 bg-green-50';
      case 'error':
        return 'border-red-200 bg-red-50';
      default:
        return 'border-blue-200 bg-blue-50';
    }
  };

  const getProgressBarColor = () => {
    switch (status) {
      case 'success':
        return 'bg-green-500';
      case 'error':
        return 'bg-red-500';
      default:
        return 'bg-blue-500';
    }
  };

  return (
    <div className="fixed top-4 right-4 z-50 max-w-sm">
      <div 
        className={`border rounded-lg p-4 shadow-lg transition-all duration-300 ${getStatusColor()}`}
      >
        <div className="flex items-center space-x-3">
          {getStatusIcon()}
          <div className="flex-1 min-w-0">
            <div className="text-sm font-medium text-gray-900 truncate">
              {filename || 'Uploading image...'}
            </div>
            {message && (
              <div className="text-xs text-gray-600 mt-1">
                {message}
              </div>
            )}
          </div>
        </div>
        
        {status === 'uploading' && (
          <div className="mt-3">
            <div className="flex justify-between text-xs text-gray-600 mb-1">
              <span>Uploading...</span>
              <span>{Math.round(progress)}%</span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2">
              <div 
                className={`h-2 rounded-full transition-all duration-300 ${getProgressBarColor()}`}
                style={{ width: `${progress}%` }}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProgressIndicator;